export * from './components';
export * from './maps';
export { autonomousCommunities, autonomousCommunitiesOnly } from './autonomousCommunities.contant';
export { provincesList, province } from './provinces.constant';
export { bankSpain } from './bankSpain.constant';
// Opciones de plazo de 1 a 24 meses
export const termOptions = Array.from(
	{ length: 24 },
	(_, i) => `${i + 1} mes${i === 0 ? '' : 'es'}`,
);

export { FileTypeFormation, FileNameFormation } from './formationFiles.constant';
